import UserAuthStore from "../../store/userStore";
import ChatStore from "../../store/chatStore";
import useSessionIdStore from "../../store/useSessionIdStore";
import api, { queryClient } from "../../api";
import ENDPOINTS from "../../api/endpoints";
import logger from "../../services/Logger";
import QUERYKEYS from "../../api/queryKeys";
import { broadcastInvalidate } from "../../api/broadcastSync";

export const updateChatTitle = async (uid, title, space, emitAgain, chat) => {
  const {
    setEditChatId,
    setEditTitle,
  } = ChatStore.getState();
  const { user, orgId } = UserAuthStore.getState();
  const session_id = useSessionIdStore.getState().session_id;

  // Optimistic update: Update cache immediately for instant UI feedback
  const queryKey = space?.space_id 
    ? ['spectra-sparks', space.space_id, orgId, user?.uid, space.owner_id]
    : [QUERYKEYS.CHATS, orgId, user?.uid];
  
  const previousData = queryClient.getQueryData(queryKey);
  
  queryClient.setQueryData(queryKey, (oldData) => {
    if (!oldData) return oldData;
    
    // Handle spectra-sparks nested structure { success, sparks: [...] }
    if (oldData.sparks && Array.isArray(oldData.sparks)) {
      return {
        ...oldData,
        sparks: oldData.sparks.map(c => 
          c.uid === uid ? { ...c, title: title } : c
        )
      };
    }
    
    // Handle regular chats array
    if (Array.isArray(oldData)) {
      return oldData.map(c => 
        c.uid === uid ? { ...c, title: title } : c
      );
    }
    
    return oldData;
  });

  try {
    // Call backend API to update title and emit events
    await api({
      method: "POST",
      url: ENDPOINTS.UPDATE_SPARK_TITLE,
      data: {
        chat_id: uid,
        title: title,
        org_id: orgId,
        user_id: user.uid,
        owner_id: space?.owner_id ?? chat?.owner_id ?? user.uid,
        space_id: space?.space_id,
        session_id: session_id,
      },
    });

    // Reset editing states (UI only)
    setEditChatId("");
    setEditTitle("");
    broadcastInvalidate(queryKey);
  } catch (error) {
    // Rollback on error
    queryClient.setQueryData(queryKey, previousData);
    logger.error('updateChatTitle', 'Error updating chat title', { error: error.message, uid, title });
  }
};
